"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = void 0;
const types_1 = require("../lib/types");
const axios_1 = require("./axios");
const getHttpErrorMessage_1 = require("./getHttpErrorMessage");
const post = (payload, config) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const { relayCall, request } = payload;
        let path;
        switch (relayCall) {
            case types_1.RelayCall.CallWithSyncFee:
                path = `${config.url}/relays/v2/call-with-sync-fee`;
                break;
            case types_1.RelayCall.CallWithSyncFeeERC2771:
                path = `${config.url}/relays/v2/call-with-sync-fee-erc2771`;
                break;
            case types_1.RelayCall.SponsoredCall:
                path = `${config.url}/relays/v2/sponsored-call`;
                break;
            case types_1.RelayCall.SponsoredCallERC2771:
                path = `${config.url}/relays/v2/sponsored-call-erc2771`;
                break;
            default: {
                const _exhaustiveCheck = relayCall;
                return _exhaustiveCheck;
            }
        }
        return (yield axios_1.axiosInstance.post(path, request)).data;
    }
    catch (error) {
        throw new Error((0, getHttpErrorMessage_1.getHttpErrorMessage)(error));
    }
});
exports.post = post;
